import React from "react";
import {useSelector} from "react-redux";
import {selectUserLocation} from "../stores/account/account.selectors";
import {FormattedMessage} from "react-intl";

const canadaResGamingResource = {
    "AB":{
        name: "Problem Gambling Resources Network",
        phone: "1-866-461-1259"
    },
    "BC":{
        name: "Problem Gambling Help Line",
        phone: "1-888-795-6111"
    },
    "QC":{
        name: "Help and Referral",
        phone: "1-800-461-0140",
    },
    "MB":{
        name: "Addictions Help Line – Problem Gambling",
        phone: "1-800-463-1554"
    },
    "NL":{
       name: "Problem Gambling Help Line",
       phone: "1-888-899-4357"
    },
    "NB":{
        name: "Gambling Information Line",
        phone: "1-800-461-1234"
    },
    "NT":{
        name: "General Help Line",
        phone: "1-800-661-0844",
    },
    "NS":{
        name: "Problem Gambling Help Line",
        phone: "1-888-347-8888"
    },
    "NV":{
        name: "Help Line",
        phone: "1-800-265-3333"
    },
    "ON":{
        name: "Help Line",
        phone: "1-866-531-2600"
    },
    "PEI":{
        name: "Problem Gambling Help Line",
        phone: "1-855-255-4255"
    },
    "SK":{
        name: "Problem Gambling Helpline",
        phone: "1-800-306-6789"
    },
    "YK":{
        name: "Mental Wellness and Substance Use Services",
        phone: "1-866-456-3838"
    },
    "default":{ //ON
        name: "Help Line",
        phone: "1-866-531-2600",
        link: "https://www.responsiblegambling.org/for-the-public/problem-gambling-help/help-for-canadians/"
    }
};

const mexicoGamingResource = {
    name: "Dirección General de Juegos y Sorteos",
    phone: "800 911 2000",
    link: "https://www.juegosysorteos.gob.mx/es/Juegos_y_Sorteos/Atencion_al_Ludopata"
}

const franceGamingResource = {
    name: "Joueurs info service",
    phone: "https://www.joueurs-info-service.fr/",
    link: "09-74-75-13-13"
};

const usGamingResource = {
    name: "Nation Council on Problem Gaming",
    link: "https://www.ncpgambling.org/",
    phone: "1-800-522-4700"
}

const useResponsibleGamingTextByCountry = ()=>{
    const userLocation = useSelector(selectUserLocation);

    let resource = null;
    let responsibleGamingResource = "";
    let phoneNumber = "";
    let link = "";

    switch (userLocation?.countryCode){
        case "CA":
            resource = canadaResGamingResource[userLocation?.regionCode] || canadaResGamingResource["default"];
            responsibleGamingResource = userLocation?.regionCode + " " + resource.name
            phoneNumber = resource.phone;
            link = canadaResGamingResource["default"].link;
            break;
        case "MX":
            responsibleGamingResource = mexicoGamingResource.name;
            phoneNumber = mexicoGamingResource.phone;
            link = mexicoGamingResource.link;
            break;
        case "FR":
            responsibleGamingResource = franceGamingResource.name;
            phoneNumber = franceGamingResource.phone;
            link = franceGamingResource.link;
            break;
        default:
            responsibleGamingResource = usGamingResource.name;
            phoneNumber = usGamingResource.name;
            link = usGamingResource.link;
            break;
    }

    let title = <FormattedMessage id="termsOfUse.responsibleGamingLabel"/>;
    let content =  <FormattedMessage id="termsOfUse.responsibleGamingNote" values={{
        responsibleGamingResource,
        phoneNumber
    } } />;

    return {title, content, link}
}
export default useResponsibleGamingTextByCountry;